import * as yup from 'yup';
import { isEmpty } from 'lodash';

import {
  requiredConstant,
  passwordRegex,
  passwordValidConstant,
  emailRegex,
  emailValidConstant,
  urlRegex,
  urlValidConstant,
  phoneRegex,
} from 'common/utils/constants';

export const emailYup = yup
  .string()
  .email(emailValidConstant)
  .required(requiredConstant)
  .matches(emailRegex, emailValidConstant);

export const urlYup = yup
  .string()
  .required(requiredConstant)
  .matches(urlRegex, urlValidConstant);

export const passwordYup = yup
  .string()
  .matches(passwordRegex, passwordValidConstant)
  .required(requiredConstant);

export const nameYup = yup.string().required(requiredConstant);
export const phoneNumberYup = yup
  .string()
  .matches(phoneRegex, 'Phone number is not valid');

export const signInSchema = yup.object().shape({
  username: emailYup,
  password: passwordYup,
});

export const signInVerificationSchema = yup.object().shape({
  code: yup.string().required(requiredConstant),
});

export const ConfirmPasswordSchema = yup.object().shape({
  password: passwordYup,
  newPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
});

export const ForgotPasswordSchema = yup.object().shape({
  username: emailYup,
});

export const ResetPasswordSchema = yup.object().shape({
  password: passwordYup,
  newPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
});

export const SignUpSchema = yup.object().shape({
  name: nameYup,
  email: emailYup,
  password: passwordYup,
  linkedinUrl: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => !isEmpty(value),
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
  crunchbaseUrl: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => !isEmpty(value),
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
  anglelistUrl: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => !isEmpty(value),
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
  twitterUrl: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => !isEmpty(value),
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
  otherUrl: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => !isEmpty(value),
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
  termsAccepted: yup.boolean().oneOf([true]).required(),
});

export const CompleteProfileSchema = yup.object().shape({
  linkedinUrl: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => !isEmpty(value),
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
  crunchbaseUrl: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => !isEmpty(value),
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
  anglelistUrl: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => !isEmpty(value),
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
  twitterUrl: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => !isEmpty(value),
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
  otherUrl: yup
    .string()
    .nullable()
    .when({
      is: (value: string) => !isEmpty(value),
      then: yup.string().matches(urlRegex, urlValidConstant),
    }),
});
